import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

axios.interceptors.request.use(
  async request => {
    if (!request.headers.Authorization) {
      const token = localStorage.getItem('accessToken');

      if (token) {
        request.headers.Authorization = `Bearer ${token}`;
      }
    }
    
    return request;
  },
  error => {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const { response } = error;

    if (response.data && response.data.error) {
      return Promise.reject(response.data.error);
    }

    return Promise.reject(error);
  },
);
